/**
 * Количество секунд, через сколько пользователь сможет отправить код повторно
 * */
export const SEND_CODE_ATTEMPT_COUNTDOWN_FROM = 60;
